import React from "react";

export default () => {

    return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
        <defs>
            <clipPath id="clip-path">
                <rect id="Rectangle_2871" data-name="Rectangle 2871" width="18" height="16" transform="translate(-0.044 -0.165)"/>
            </clipPath>
        </defs>
        <g transform="translate(0.54 0.401)">
            <g transform="translate(-0.496 -0.236)" clipPath="url(#clip-path)">
                <path d="M7.3.082a.723.723,0,0,1,.306.972L5.158,5.769h6.988L9.694,1.054a.721.721,0,1,1,1.28-.665l2.8,5.379h2.572a.961.961,0,0,1,0,1.923l-1.559,6.234a1.945,1.945,0,0,1-1.866,1.457H4.359A1.916,1.916,0,0,1,2.52,13.925L.961,7.691a.961.961,0,0,1,0-1.923H3.533L6.33.389A.722.722,0,0,1,7.3.082M4.326,8.893A.721.721,0,1,0,3.6,8.172a.719.719,0,0,0,.721.721m8.652-1.442a.721.721,0,1,0,.721.721.719.719,0,0,0-.721-.721" transform="translate(0.304 0.145)"/>
            </g>
        </g>
    </svg>


}
